import React from "react";
import { useSelector } from "react-redux";
import FundraisingDashboardButton from "./FundraisingDashboardButton";
import { selectRegistrationAccount } from "../../../../redux/slices/registrationAccountSlice";

const ConnectedFundraisingDashboardButton = () => {
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        global: { hasActiveGlobalAccount, hasSocialLogins, isLoggedIn },
        urls: { donorActionUrl, eventHome, myFundraisingDashboard },
    } = registrationAccount;

    const fundraisingDashboardButtonProps = {
        hasActiveGlobalAccount,
        hasSocialLogins,
        isLoggedIn,
        donorActionUrl,
        eventHome,
        myFundraisingDashboard,
    };

    return <FundraisingDashboardButton {...fundraisingDashboardButtonProps} />;
};

export default ConnectedFundraisingDashboardButton;
